<template>
  <li>
    <div v-if="membershipType.logo_image" class="image">
      <picture>
        <source
          :srcset="membershipType.logo_image_optimized"
          type="image/webp"
        />
        <source :srcset="membershipType.logo_image" type="image/jpeg" />
        <img
          :src="membershipType.logo_image"
          :alt="`${membershipType.name} Logo`"
        />
      </picture>
    </div>
    <div class="copy">
      <client-only>
        <h2
          v-if="membershipType.subheading"
          v-html="membershipType.subheading"
        />
        <p v-html="membershipType.gifting_blurb" />
        <p>{{ membershipType.gift_delivery_frequency }}.</p>
      </client-only>
    </div>
    <div class="item-footer">
      <p>
        <strong
          >{{ membershipType.bottles_per_delivery }} Bottle{{
            membershipType.bottles_per_delivery > 1 ? 's' : ''
          }}
          per Shipment</strong
        >
      </p>
      <p v-if="shortenedPriceString">
        <strong>{{ shortenedPriceString }} per Shipment</strong>
        Shipping included + applicable tax
      </p>
      <nuxt-link :to="linkUrl" class="more button">{{ ctaText }}</nuxt-link>
    </div>
  </li>
</template>

<script>
export default {
  name: 'WineClubCard',
  props: {
    membershipType: {
      type: Object,
      required: true,
    },
    linkUrl: {
      type: String,
      required: true,
    },
    ctaText: {
      type: String,
      required: true,
    },
    usePriceRange: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    shortenedPriceString() {
      const re = /(?:\$\d*)/gm
      const matchResult = this.membershipType.pricing_info.match(re)
      if (matchResult) {
        const upperPrice = matchResult.slice(-1).pop() || ''
        if (!this.usePriceRange) return upperPrice
        let priceRange = this.membershipType.pricing_info.match(re)[0] || ''
        if (priceRange !== upperPrice) priceRange += '-' + upperPrice
        return priceRange
      }
      return ''
    },
  },
}
</script>
